import image9 from "assets/img/about-project/o-projekcie-1.jpg";
import image5 from "assets/img/team/adam.jpg";
import image2 from "assets/img/team/angela.jpg";
import image4 from "assets/img/team/iga.jpg";
import image8 from "assets/img/team/kamil.jpg";
import image6 from "assets/img/team/kinga.jpg";
import image3 from "assets/img/team/kuba.jpg";
import logo_azoty from "assets/img/team/logo_azoty.png";
import ministerstwo_logo from "assets/img/team/ministerstwo_logo.png";
import image7 from "assets/img/team/seba.jpg";
import szkola_filmowa from "assets/img/team/szkola_filmowa.png";
import vn_logo from "assets/img/team/vn_logo.png";
import "assets/scss/archive/mine-now.scss";
import "assets/scss/Components/spyscroll.scss";
import "assets/scss/Views/paralax.scss";
import ParalaxElement from "Components/Paralax/ParalaxElement";
import { useMemo } from "react";
import { useLayoutEffect } from "react";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Scrollspy from "react-scrollspy";
import { animated, useTransition } from "react-spring";

const AboutTeam = ({
  setPageTitle,
  setShowMenuToggler,
  setIsBackgroundMusic,
  setReturnLink,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    setPageTitle(t("Team"));
    setShowMenuToggler(true);
    setIsBackgroundMusic(true);
    setReturnLink({ link: "/scene" });
  }, [setPageTitle, setShowMenuToggler, setReturnLink, setIsBackgroundMusic]);
  const useHover = () => {
    const [hovered, setHovered] = useState();
    const eventHandlers = useMemo(
      () => ({
        onMouseOver(e) {
          setHovered(e.target.id);
        },
        onMouseOut(e) {
          setHovered(0);
        },
      }),
      []
    );

    return [hovered, eventHandlers];
  };
  const [activePage, setActivePage] = useState(0);
  const transitions = useTransition(activePage, {
    opacity: 1,
    value: 100,
    key: activePage,
    from: { opacity: 0, value: 0 },
    enter: { opacity: 1, value: 100 },
    config: { duration: 1000 },
    exitBeforeEnter: true,
  });
  const updateHandler = (e) => {
    if (!e) {
      return;
    }
    setActivePage(parseInt(e.getAttribute("id").replace("section-", "")));
  };
  const [hovered, eventHandlers] = useHover(0);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Fragment>
      <div className="scrollspy-wrapper">
        <Scrollspy
          onUpdate={updateHandler}
          className="scrollspy"
          items={[
            "section-1",
            "section-2",
            "section-3",
            "section-4",
            "section-5",
            "section-6",
          ]}
          currentClassName="active"
        >
          <li>
            <a href="#section-1">&nbsp;</a>
          </li>
          <li>
            <a href="#section-2">&nbsp;</a>
          </li>
          <li>
            <a href="#section-3">&nbsp;</a>
          </li>
          <li>
            <a href="#section-4">&nbsp;</a>
          </li>
          <li>
            <a href="#section-5">&nbsp;</a>
          </li>
          <li>
            <a href="#section-6">&nbsp;</a>
          </li>
        </Scrollspy>
      </div>
      <section id="section-1" className="vh-50"></section>
      <section id="section-2" className="vh-50"></section>
      <section id="section-3" className="vh-50"></section>
      <section id="section-4" className="vh-50"></section>
      <section id="section-5" className="vh-50"></section>
      <section id="section-6" className="vh-100"></section>
      <section id="section-8" className="vh-75">
        <div
          style={{ marginTop: "-180px" }}
          className="paralax__list d-flex flex-column justify-content-center align-items-center z-index-10"
        >
          <ParalaxElement
            ev={{ hovered, eventHandlers }}
            id={1}
            title={t("AboutTeamList1Title")}
            szkola_filmowa
            content={
              <div style={{ height: "40px" }}>
                <img height="50px" src={szkola_filmowa} className="" alt="" />
                <img
                  height="30px"
                  src={vn_logo}
                  className="ms-5"
                  alt="Logo VN_LAB"
                />
                <p></p>
              </div>
            }
          />
          <ParalaxElement
            ev={{ hovered, eventHandlers }}
            id={2}
            title={t("AboutTeamList2Title")}
            content={"Katarzyna Boratyn, Krzyszof Pijarski"}
          />
          <ParalaxElement
            ev={{ hovered, eventHandlers }}
            id={3}
            title={t("AboutTeamList3Title")}
            content={t("AboutTeamList3Content")}
          />
          <ParalaxElement
            ev={{ hovered, eventHandlers }}
            id={4}
            title={t("AboutTeamList4Title")}
            content={"Katarzyna Boratyn"}
          />
          <ParalaxElement
            ev={{ hovered, eventHandlers }}
            id={5}
            title={t("AboutTeamList5Title")}
            content={
              "Dorota Schreiber, Małgorzata Czarnecka, Magda Kowalska, Magda Wołowska"
            }
          />
          <ParalaxElement
            ev={{ hovered, eventHandlers }}
            id={6}
            title={t("AboutTeamList6Title")}
            content={
              "Iwona Kopeć, Agata Arabska, Elżbieta Cota, Aneta Kulińska, Monika Duraj, Dorota Czopczyńska, Magdalena Drzewiecka"
            }
          />
          <ParalaxElement
            ev={{ hovered, eventHandlers }}
            id={7}
            title={t("AboutTeamList7Title")}
            content={"Monika Żelazowska, Monika Gromotowicz"}
          />
          <ParalaxElement
            ev={{ hovered, eventHandlers }}
            id={8}
            title={t("AboutTeamList8Title")}
            content={"Maria Kowalska-Bieniek"}
          />
          <ParalaxElement
            ev={{ hovered, eventHandlers }}
            id={18}
            title={t("Maintenance")}
            content={"Piotr Staruch"}
          />
          <ParalaxElement
            ev={{ hovered, eventHandlers }}
            id={9}
            title={t("AboutTeamList9Title")}
            content={"Krzysztof Franek & Krzysztof Pijarski"}
          />
          <ParalaxElement
            ev={{ hovered, eventHandlers }}
            id={10}
            title={t("AboutTeamList10Title")}
            content={t("AboutTeamList10Content")}
          />

          <ParalaxElement
            ev={{ hovered, eventHandlers }}
            id={11}
            title={t("AboutTeamList11Title")}
            content={t("AboutTeamList11Content")}
          />
          <ParalaxElement
            ev={{ hovered, eventHandlers }}
            id={12}
            title={t("AboutTeamList12Title")}
            content={t("AboutTeamList12Content")}
          />
          <ParalaxElement
            ev={{ hovered, eventHandlers }}
            id={13}
            title={t("AboutTeamList13Title")}
            content={t("AboutTeamList13Content")}
          />
          <ParalaxElement
            ev={{ hovered, eventHandlers }}
            id={14}
            title={"Krzysztof Pijarski"}
            content={
              <div style={{ height: "40px" }}>
                <img
                  height="30px"
                  src={vn_logo}
                  className=""
                  alt="Logo VN_LAB"
                />
                <p></p>
              </div>
            }
          />
          <ParalaxElement
            ev={{ hovered, eventHandlers }}
            id={15}
            title={"Katarzyna Boratyn"}
            content={
              <div style={{ height: "40px" }}>
                <img
                  height="30px"
                  src={vn_logo}
                  className=""
                  alt="Logo VN_LAB"
                />
                <p></p>
              </div>
            }
          />
          <ParalaxElement
            ev={{ hovered, eventHandlers }}
            id={19}
            title={'Kamila Wdowska'}
            content={t("AboutTeamList19Title")}
          />
          <ParalaxElement
            ev={{ hovered, eventHandlers }}
            id={16}
            title={t("AboutTeamList16Title")}
            content={
              <div style={{ height: "50px" }}>
                <img height="50px" src={logo_azoty} className="" alt="" />
                <p></p>
              </div>
            }
          />
          <ParalaxElement
            ev={{ hovered, eventHandlers }}
            id={17}
            title={t("AboutTeamList17Title")}
            content={
              "Frédéric Dubois, Sandra Gaudenzi, Aleksander Dyl, Teresa Tałaj, Michał Tałaj, Bożena Żugaj, Henryka Tomtas, Mieczysława Dziuba, Anna Nowak, Teresa Wyrzykowska, Kasia Wyrzykowska, Teresa Okoń, Danuta Serwan, Maria Cebula, Jakub Gad, Mateusz Brzezicki, Agnieszka Kuraś, Klaudia Fudalewska, Jakub Fudalewski, Patryk Podsiadło, Gosia Guzik, Aleksandra Filimowska, Mateusz Ciszkiewicz"
            }
          />
          <div className="col-8 mx-auto">
            <h5 className="mt-4 mb-100 text-center">{t("Copyright")}</h5>
          </div>
          <h1> </h1>
        </div>
      </section>
      <section className="fixedSection">
        {transitions((props, item, key) => {
          return (
            <Fragment>
              {item === 1 && (
                <animated.div style={{ opacity: props.opacity }}>
                  <div className="w-100 vh-100 d-flex flex-column justify-content-end align-items-center position-relative z-index-11">
                    <div className="d-flex flex-row justify-content-center align-items-center h-100 w-100">
                      <div className="col-6 d-flex justify-content-center position-relative align-items-end h-100 overflow-hidden">
                        <div className="col-12 col-md-10 col-xl-8 z-index-11 position-absolute d-flex flex-column text-center justify-content-start align-items-center mb-100 pb-5 px-5 min-h-300">
                          <h4 className="text-center">{t("Team")}</h4>
                          <span className="d-block fs-14 text-uppercase pb-10">
                            {t("TeamSection1Title")}
                          </span>
                          <span className="d-block mt-20">
                            {t("TeamSection1Content")}
                          </span>
                        </div>
                        <animated.div
                          className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-img dark-layer2"
                          style={{
                            backgroundImage: `url(${image9})`,
                            left:
                              item === 1
                                ? props.value.to((y) => {
                                    return `${100 - y}%`;
                                  })
                                : 0,
                          }}
                        />
                      </div>
                      <div className="col-6 d-flex justify-content-center position-relative align-items-end h-100 overflow-hidden">
                        <div className="col-12 col-md-10 col-xl-8 z-index-11 position-absolute d-flex flex-column text-center justify-content-start align-items-center mb-100 pb-5 px-5 min-h-300">
                          <h4 className="text-center">
                            {" "}
                            {t("TeamSection2Title")}
                          </h4>
                          <span className="d-block fs-14 text-uppercase pb-10">
                            {t("TeamSection2Description")}
                          </span>
                          <span className="d-block mt-20">
                            {t("TeamSection2Content")}
                          </span>
                        </div>
                        <animated.div
                          className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-img dark-layer2"
                          style={{
                            backgroundImage: `url(${image2})`,
                            right:
                              item === 1
                                ? props.value.to((y) => {
                                    return `-${50 - y / 2}%`;
                                  })
                                : 0,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </animated.div>
              )}
              {item === 2 && (
                <animated.div style={{ opacity: props.opacity }}>
                  <div className="w-100 vh-100 d-flex flex-column justify-content-end align-items-center position-relative z-index-11">
                    <div className="d-flex flex-row justify-content-center align-items-center h-100 w-100">
                      <div className="col-6 d-flex justify-content-center position-relative align-items-end h-100 overflow-hidden">
                        <div className="col-12 col-md-10 col-xl-8 z-index-11 position-absolute d-flex flex-column text-center justify-content-start align-items-center mb-100 pb-5 px-5 min-h-300">
                          <h4 className="text-center">
                            {t("TeamSection3Title")}
                          </h4>
                          <span className="d-block fs-14 text-uppercase pb-10">
                            {t("TeamSection3Description")}
                          </span>
                          <span className="d-block mt-20">
                            {t("TeamSection3Content")}
                          </span>
                        </div>
                        <animated.div
                          className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-img dark-layer2"
                          style={{
                            backgroundImage: `url(${image3})`,
                            left:
                              item === 2
                                ? props.value.to((y) => {
                                    return `${100 - y}%`;
                                  })
                                : 0,
                          }}
                        />
                      </div>
                      <div className="col-6 d-flex justify-content-center position-relative align-items-end h-100 overflow-hidden">
                        <div className="col-12 col-md-10 col-xl-8 z-index-11 position-absolute d-flex flex-column text-center justify-content-start align-items-center mb-100 pb-5 px-5 min-h-300">
                          <h4 className="text-center">
                            {t("TeamSection4Title")}
                          </h4>
                          <span className="d-block fs-14 text-uppercase pb-10">
                            {t("TeamSection4Description")}
                          </span>
                          <span className="d-block mt-20">
                            {t("TeamSection4Content")}
                          </span>
                        </div>
                        <animated.div
                          className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-img dark-layer2"
                          style={{
                            backgroundImage: `url(${image4})`,
                            right:
                              item === 2
                                ? props.value.to((y) => {
                                    return `-${50 - y / 2}%`;
                                  })
                                : 0,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </animated.div>
              )}
              {item === 3 && (
                <animated.div style={{ opacity: props.opacity }}>
                  <div className="w-100 vh-100 d-flex flex-column justify-content-end align-items-center position-relative z-index-11">
                    <div className="d-flex flex-row justify-content-center align-items-center h-100 w-100">
                      <div className="col-6 d-flex justify-content-center position-relative align-items-end h-100 overflow-hidden">
                        <div className="col-12 col-md-10 col-xl-8 z-index-11 position-absolute d-flex flex-column text-center justify-content-start align-items-center mb-100 pb-5 px-5 min-h-300">
                          <h4 className="text-center">
                            {t("TeamSection5Title")}
                          </h4>
                          <span className="d-block fs-14 text-uppercase pb-10">
                            {t("TeamSection5Description")}
                          </span>
                          <span className="d-block mt-20">
                            {t("TeamSection5Content")}
                          </span>
                        </div>
                        <animated.div
                          className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-img dark-layer2"
                          style={{
                            backgroundImage: `url(${image5})`,
                            left:
                              item === 3
                                ? props.value.to((y) => {
                                    return `${100 - y}%`;
                                  })
                                : 0,
                          }}
                        />
                      </div>
                      <div className="col-6 d-flex justify-content-center position-relative align-items-end h-100 overflow-hidden">
                        <div className="col-12 col-md-10 col-xl-8 z-index-11 position-absolute d-flex flex-column text-center justify-content-start align-items-center mb-100 pb-5 px-5 min-h-300">
                          <h4 className="text-center">
                            {t("TeamSection6Title")}
                          </h4>
                          <span className="d-block fs-14 text-uppercase pb-10">
                            {t("TeamSection6Description")}
                          </span>
                          <span className="d-block mt-20">
                            {t("TeamSection6Content")}
                          </span>
                        </div>
                        <animated.div
                          className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-img dark-layer2"
                          style={{
                            backgroundImage: `url(${image6})`,
                            right:
                              item === 3
                                ? props.value.to((y) => {
                                    return `-${50 - y / 2}%`;
                                  })
                                : 0,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </animated.div>
              )}
              {item === 4 && (
                <animated.div style={{ opacity: props.opacity }}>
                  <div className="w-100 vh-100 d-flex flex-column justify-content-end align-items-center position-relative z-index-11">
                    <div className="d-flex flex-row justify-content-center align-items-center h-100 w-100">
                      <div className="col-6 d-flex justify-content-center position-relative align-items-end h-100 overflow-hidden">
                        <div className="col-12 col-md-10 col-xl-8 z-index-11 position-absolute d-flex flex-column text-center justify-content-start align-items-center mb-100 pb-5 px-5 min-h-300">
                          <h4 className="text-center">
                            {t("TeamSection7Title")}
                          </h4>
                          <span className="d-block fs-14 text-uppercase pb-10">
                            {t("TeamSection7Description")}
                          </span>
                          <span className="d-block mt-20">
                            {t("TeamSection7Content")}
                          </span>
                        </div>
                        <animated.div
                          className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-img dark-layer2"
                          style={{
                            backgroundImage: `url(${image7})`,
                            left:
                              item === 4
                                ? props.value.to((y) => {
                                    return `${100 - y}%`;
                                  })
                                : 0,
                          }}
                        />
                      </div>
                      <div className="col-6 d-flex justify-content-center position-relative align-items-end h-100 overflow-hidden">
                        <div className="col-12 col-md-10 col-xl-8 z-index-11 position-absolute d-flex flex-column text-center justify-content-start align-items-center mb-100 pb-5 px-5 min-h-300">
                          <h4 className="text-center">
                            {t("TeamSection8Title")}
                          </h4>
                          <span className="d-block fs-14 text-uppercase pb-10">
                            {t("TeamSection8Description")}
                          </span>
                          <span className="d-block mt-20">
                            {t("TeamSection8Content")}
                          </span>
                        </div>
                        <animated.div
                          className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-img dark-layer2"
                          style={{
                            backgroundImage: `url(${image8})`,
                            right:
                              item === 4
                                ? props.value.to((y) => {
                                    return `-${50 - y / 2}%`;
                                  })
                                : 0,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </animated.div>
              )}
              {item === 5 && (
                <animated.div
                  style={{ opacity: props.opacity }}
                  className="z-index-11"
                >
                  <div className="w-100 vh-100 d-flex justify-content-end flex-column align-items-center position-relative">
                    <div className="d-flex flex-column justify-content-center align-items-center col-8 mt-auto">
                      <div className="col-xl-10 col-lg-12 d-flex justify-content-center align-items-center flex-column text-center">
                        <h1 className="fs-100 mb-5 text-center">
                          {t("Special Thanks")}
                        </h1>
                        <h4 className="font-normal mt-3 pt-2 mb-0 text-center">
                          {t("We thank everyone who supported this project.")}
                        </h4>
                        <span className="d-block mt-20 text-center fs-bigBody col-8 ">
                          {t("SpecialThanksContent1")}
                        </span>
                        <span className="d-block mt-20 text-center fs-14 col-8 px-5 text-uppercase">
                          {t("SpecialThanksContent2")}
                        </span>
                        <span className="d-block mt-20 text-center fs-14 col-8 px-5 text-uppercase">
                          {t("SpecialThanksContent3")}
                        </span>
                      </div>
                    </div>
                    <div className="col-xl-5 col-lg-8 col-10 z-index-11 d-flex flex-row justify-content-between align-items-center mt-5 pb-5 mb-auto flex-wrap">
                      <img
                        src={ministerstwo_logo}
                        className=""
                        alt="Ministerstwo Nauki i Szkolnictwa Wyższego"
                      />
                      <img src={vn_logo} className="" alt="Logo VN_LAB" />
                      <img
                        src={szkola_filmowa}
                        className=""
                        alt="Szkoła Filmowa w Łodzi"
                      />
                    </div>
                  </div>
                </animated.div>
              )}
              {(item === 5 || item === 6) && (
                <animated.div className="position-fixed w-100 h-100">
                  <img
                    src={image9}
                    className="fullscreen_el position-absolute dark-layer2"
                    alt=""
                  />
                </animated.div>
              )}
            </Fragment>
          );
        })}
      </section>
    </Fragment>
  );
};

export default AboutTeam;
